// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"c3c8ee35","287":"b46eebfd","290":"c80f034a","344":"9ab7c661","550":"93e91573","608":"39b23dad","841":"0b747478"}[chunkId] + ".chunk.js";
};